import { Award, Gauge, HeartHandshake, ShieldCheck, Wrench } from "lucide-react";
import { FadeUp } from "../Reveal";

const ADVANTAGES = [
  {
    icon: Award,
    title: "Kaliteli Tarım Makineleri",
    desc: "Sağlam malzeme ve özenli imalatla, zorlu saha koşullarına dayanan makineler.",
  },
  {
    icon: ShieldCheck,
    title: "Güvenilir Hizmet",
    desc: "Verdiğimiz sözün arkasında durur, süreci baştan sona takip ederiz.",
  },
  {
    icon: HeartHandshake,
    title: "Müşteri Odaklı Yaklaşım",
    desc: "İhtiyacınıza en uygun makineyi, doğru bilgiyle öneririz.",
  },
  {
    icon: Gauge,
    title: "Verimli Çözümler",
    desc: "Zaman, yakıt ve emek tasarrufu sağlayan verimli ekipmanlar.",
  },
  {
    icon: Wrench,
    title: "Satış Sonrası Destek",
    desc: "Makineniz teslim edildikten sonra da yedek parça ve teknik destek yanınızda.",
  },
];

export default function WhyUs() {
  return (
    <section id="neden-baytas" className="relative scroll-mt-24 overflow-hidden bg-ink-deep py-20 lg:py-32">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8">
        <div className="max-w-2xl">
          <FadeUp>
            <span className="eyebrow-light">Neden Biz?</span>
          </FadeUp>
          <FadeUp delay={0.08}>
            <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-paper sm:text-4xl lg:text-5xl" data-testid="whyus-title">
              Neden Baytaş Tarım?
            </h2>
          </FadeUp>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-6">
          <FadeUp className="sm:col-span-2 lg:col-span-4">
            <div className="flex h-full flex-col justify-center rounded-lg border border-white/10 bg-ink-card p-8 lg:p-12">
              <p className="font-display text-2xl font-bold uppercase leading-tight tracking-tight text-paper sm:text-3xl lg:text-4xl" data-testid="whyus-lead">
                Güçlü makine, dürüst hizmet.
              </p>
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-paper/70 sm:text-base">
                Baytaş Tarım, ürününü kullanan çiftçinin yanında olmayı işinin parçası sayar.
                Sahada çalıştığı bilinen makineler üretir, hem satışta hem sonrasında destek olur.
              </p>
            </div>
          </FadeUp>

          {ADVANTAGES.map((adv, i) => (
            <FadeUp key={adv.title} delay={0.05 * (i + 1)} className="lg:col-span-2">
              <div
                className="h-full rounded-lg border border-white/10 bg-ink-card p-6 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-amber/40 lg:p-8"
                data-testid={`whyus-advantage-${i}`}
              >
                <span className="grid h-11 w-11 place-items-center rounded-md border border-amber/30 bg-amber/15 text-amber">
                  <adv.icon size={20} />
                </span>
                <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-tight text-paper">
                  {adv.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-paper/65">{adv.desc}</p>
              </div>
            </FadeUp>
          ))}

          <FadeUp delay={0.1} className="lg:col-span-4">
            <figure className="relative h-full min-h-[220px] overflow-hidden rounded-lg border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1729454854315-4bd98d945f7e?auto=format&fit=crop&w=1600&q=80"
                alt="Baytaş Tarım diskaro makinesi tarlada"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink-deep/80 to-transparent p-5 pt-12 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/85">
                Baytaş Tarım makineleri sahada
              </figcaption>
            </figure>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}